/**
 * Internal dependencies
 */
export type CreateFolderClickDatalayerProps = {
	folderAmount: string;
	totalRecipeCount: string;
};

/**
 * Pushes an event to the data layer when the create folder button is clicked.
 * This is used for analytics tracking.
 * @param {CreateFolderClickDatalayerProps} props                  - The properties for the event.
 * @param {string}                          props.folderAmount     - The amount of folders.
 * @param {string}                          props.totalRecipeCount - The total number of recipes.
 * @return {void}
 */
export function pushKeittokirjaCreateFolderClick({
	folderAmount,
	totalRecipeCount,
}: CreateFolderClickDatalayerProps): void {
	const isProduction = Boolean(window.valioAnalytics.isProduction);
	const datalayerObject = {
		event: 'keittokirja_create_folder_click',
		folder_amount: folderAmount,
		total_recipe_count: totalRecipeCount,
	};

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(datalayerObject);

	if (!isProduction) {
		// eslint-disable-next-line no-console
		console.log('🔍 DataLayer: keittokirja_create_folder_click', datalayerObject);
	}
}
